/**
 * Labstep
 *
 * @module containers/ActiveEditModal
 * @desc Active Edit Modal container
 */

import {
  selectActiveEditModal,
  setActiveEditModal,
} from 'labstep-web/state/slices/activeEditModal';
import { connect } from 'react-redux';
import type { WithActiveEditModalInjectedProps } from './types';

const mapStateToProps = (state: any) => ({
  activeEditModal: selectActiveEditModal(state),
});

const mapDispatchToProps = {
  setActiveEditModal,
};

export const withActiveEditModal = <
  P extends WithActiveEditModalInjectedProps,
  S,
>(
  Component: React.FC<P> | React.ComponentClass<P, S>,
): React.FC<
  Pick<P, Exclude<keyof P, keyof WithActiveEditModalInjectedProps>>
> => connect(mapStateToProps, mapDispatchToProps)(Component as any);
